<template>
  <a-form layout="vertical" :model="formState" ref="formRef" class="wait-time">
    <DisabledContainer :isDisabled="disabled">
      <a-form-item name="time_waiting" required label="Segundos a esperar por una respuesta">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.time_waiting"
          ref="select"
          placeholder="Tiempo de espera"
        >
          <a-select-option v-for="item in timeWaitingList" :key="item" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>

        <p class="info">Se recomienda brindar un mínimo de 5 segundos al contacto</p>
      </a-form-item>
    </DisabledContainer>

    <ActionPicker
      v-if="node"
      isDefaultOption
      :node="node"
      :parentNode="parentNode"
      :disabled="disabled"
    />
  </a-form>
</template>

<script setup lang="ts">
import { provide, reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { CreateNodeBody, Node } from "@/@types/ivr";
import { DrawerFormStateKey } from "@/@types/ivr/symbols";

import ActionPicker from "@/app/ivr/bot/components/pickers/ActionPicker.vue";
import DisabledContainer from "@/app/shared/components/molecules/DisabledContainer.vue";

const props = defineProps<{
  node?: Node;
  parentNode?: Node;
  disabled?: boolean;
}>();

const formRef = ref<FormInstance>();
const formState = reactive<Partial<CreateNodeBody>>({
  time_waiting: props.node?.time_waiting,
});

const timeWaitingList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

provide(DrawerFormStateKey, formState);

defineExpose({ formState, formRef });
</script>

<style scoped lang="sass">

.info
  color: $text-secondary

.wait-time
  margin-top: 16px

p
  margin: 0
  color: $gray-8
</style>
